import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: "",
            obligatorio: false
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    getData() {
        const { nombre, obligatorio } = this.state;
        return {
            nombre: nombre,
            obligatorio: obligatorio
        }
    }

    setData(data) {
        this.setState({
            nombre: data.nombre,
            obligatorio: data.obligatorio
        })
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plan.campos.edit}
                postUrl={api.proyectos.config.plan.campos.edit}
                onSubmit={() => this.props.onSubmit()}
                onPreSubmit={() => this.getData()}
                onGotData={(data) => this.setData(data)}
                id={this.props.id}
                successMessage={"El Campo del Plan de Trabajo ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Campo del Plan de Trabajo"}
                buttonTitle={"Editar Campo del Plan de Trabajo"}
                buttonIcon={"fa fa-pencil fa-lg"}

                saveButton={true}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input value={this.state.nombre} onChange={(e) => this.setState({ nombre: e.target.value })} type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>
                            Obligatorio
                            <input className="ml-2" checked={this.state.obligatorio} onChange={(e) => this.setState({ obligatorio: !this.state.obligatorio })} type="checkbox" name="obligatorio"></input>
                        </Label>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Campos/Edit.js